var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#1E1E1E",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6c.532 0 1.033.138 1.466.382.466.262.855.644 1.125 1.105.26.444.409.961.409 1.513 0 .549-.147 1.063-.404 1.506-.268.459-.653.84-1.115 1.103C10.044 11.86 9.54 12 9 12a2.99 2.99 0 0 1-2.121-.879A2.99 2.99 0 0 1 6 9c0-.828.336-1.578.879-2.121A2.99 2.99 0 0 1 9 6ZM9 3V0M9 18v-3M15 9h3M0 9h3M13.243 4.757l2.121-2.121M2.636 15.364l2.121-2.121M13.243 13.243l2.121 2.121M2.636 2.636l2.121 2.121"
  }))));
};
export default SvgSun;